<template>
	<div class="content">
		<div class="mt20 adbox white-bg" v-if="JSON.stringify(listDetails) != '{}'">
			<i class="adbx_i" v-if="listDetails.runStatus ==2">已过期</i>
			<i class="adbx_i adbx_i2" v-if="listDetails.runStatus ==1">征集中</i>
			<div class="adtitle">
				<h1>{{listDetails.eventName}}</h1>
				<div class="adtitletips">
					时间：{{$dayjs(listDetails.startTime).format('YYYY年MM月DD日')}} -
					{{$dayjs(listDetails.endTime).format('YYYY年MM月DD日')}}
					<span>|</span>
					阅读：{{listDetails.viewCount}}
				</div>
			</div>
			<div class="ad_cons">
				<div class="ad_conLeft">
					<el-image :src="listDetails.picture"></el-image>
				</div>
				<div class="adright">
					<h3>类别：<span>{{type}}</span></h3>
					<h3>主办：<span>{{listDetails.sponsor}}</span></h3>
					<h3>活动详情：</h3>
					<div class="adtext con_text">
						{{listDetails.introduce}}
					</div>

					<div v-if="tagsArr.length != 0">
						<h3>活动标签：</h3>
						<div class="adtag">
							<el-tag size="small" type="success" v-for="(item,index) in tagsArr">{{item}}
							</el-tag>
						</div>
					</div>
					<div class="adnum">
						<span v-for="(item,index) in userList.slice(0,6)" :key="index">
							<img :src="item.userAvatar" />
						</span>
						<span>···</span>
						<i>{{userList.length}}人参加</i>
					</div>

					<div v-if="listDetails.runStatus ==2">
						<el-button type="primary" disabled>活动已结束</el-button>
					</div>
					<div v-else>
						<el-button v-if="listDetails.num<listDetails.maxCount" @click="toUpWork" type="primary">上传作品
						</el-button>
						<el-button v-else type="primary" disabled>活动人数上限</el-button>
					</div>
				</div>
			</div>

			<div class="mb20">
				<h2 class="mt20">设计说明</h2>
				<div class="con_text mt10">
					<div v-html="stringHtml(design)"></div>
				</div>
			</div>
		</div>
		<div v-if="workArr.length !=0">
			<div class="flexween actfoottitle">
				<h2>全部作品<b>({{workArr.length}})</b></h2>
				<div><span @click="getWorks('viewCount')">按浏览量</span><i>|</i>
					<span @click="getWorks('createTime')">按创建时间</span><i>|</i>
					<span @click="getWorks('favourCount')">点赞数最多</span>
				</div>
			</div>
			<div>
				<newlist :list="workArr"></newlist>
				<div class="pagination">
					<el-pagination background :page-size="pageSize" @current-change="handleCurrentChange"
						current-page.sync="1" layout="prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	// import {
	// 	compact
	// } from 'lodash'
	
	let compact = require('lodash/compact')
	
	import newlist from '../../components/list/worklist.vue'
	export default {
		name: 'activetydetails',
		components: {
			newlist
		},
		data() {
			return {
				times: '',
				src: '',
				listDetails: [],
				//tag标签
				workArr: [],
				// 参与人数
				userList: [],
				//设计说明
				design: '',
				tagsArr: [],
				type: '',
				workslist: [],
				pageNum: 1,
				pageSize: 24,
				total: 0,
				orderByColumn: ''
			};
		},
		created() {
			this.getlist()
			this.getWorks()
		},
		methods: {
			//去参加上传作品
			toUpWork() {
				this.$router.push({
					name: 'upwork',
					query: {
						eventId: this.$route.query.eventId
					}
				})
			},
			async getWorks(orderByColumn) {
				const res = await this.$axios.get('/front/listWorks', {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					eventId: this.$route.query.eventId,
					orderByColumn: orderByColumn,
					isAsc: 'descending'
				})
				this.workArr = res.rows
				// console.log(this.workslist);
			},
			async getlist() {
				const res = await this.$axios.get('/front/eventView', {
					eventId: this.$route.query.eventId
				})
				this.listDetails = res.data
				this.tagsArr = compact(res.data.tags.split(','))
				this.userList = res.data.appEventUserList
				this.design = res.data.content
				this.getDict()
			},
			async getDict() {
				const res = await this.$axios.get('/front/dict', {
					dictType: 'app_event_type'
				})
				res.data.forEach(item => {
					if (this.listDetails.type == item.dictValue) this.type = item.dictLabel
				})
			},
			handleCurrentChange(val) {
				this.pageNum = val
				this.getWorks()
			},
			// 转码
			stringHtml(htmlstr) {
				htmlstr = htmlstr.replace(/\s*\b(alt|href|class|id|lang)=".*?"/g, '')
				htmlstr = htmlstr.replace(/&lt;/g, '<')
				htmlstr = htmlstr.replace(/&gt;/g, '>')
				var regex2 = new RegExp("(i?)(\<img.*?style=['\"])([^\>]+\>)", "gmi");
				htmlstr = htmlstr.replace(regex2, "$2display:block;max-width:100%;height:auto;$3");
				return htmlstr
			}
		}
	}
</script>
<style lang="scss" scoped>
	.actfoottitle {
		color: var(--black);

		span {
			cursor: pointer;
		}

		span:hover {
			color: var(--brand);
		}

		i {
			display: inline-block;
			margin: 0 14px;
		}
	}

	.footh3:hover {
		cursor: pointer;
		color: var(--brand);
	}

	.con_text {
		color: var(--info);
		font-size: 16px;
		line-height: 180%;
		text-align: justify;
		padding: 0 20px;
	}

	.elicons {
		color: var(--brand);
		font-size: 20px;
		margin-right: 10px;
	}

	.adline {
		margin: 20px 0;
		height: 1px;
		background-color: var(--border);
	}

	.adbox {
		padding: 20px 20px 1px 20px;
		margin-bottom: 20px;
		position: relative;

		.adbx_i {
			position: absolute;
			right: 30px;
			font-size: 28px;
			color: var(--info);
			background-color: var(--hovbg);
			padding: 3px;
			font-weight: bold;
			transform: rotate(30deg);
			width: 120px;
			top: 50px;
			text-align: center;
		}

		.adbx_i2 {
			background-color: var(--brand);
			color: var(--white);
		}

		.adtips {
			h3 {
				color: var(--brand);
			}
		}

		.adtitle {
			margin: 4px 0;

			.adtitletips {
				font-size: 14px;
				color: var(--info);

				span {
					display: inline-block;
					margin: 0 10px;
				}
			}
		}

		.ad_cons {
			display: flex;
			margin-top: 20px;
			align-items: flex-start;

			.ad_conLeft {
				width: 500px;
				border-radius: 10px;
				overflow: hidden;
			}

			.adright {
				flex: 1;
				margin-left: 20px;

				h3 {
					margin-bottom: 14px;
				}

				.adtext {
					line-height: 160%;
					margin-bottom: 10px;
					padding: 0;
				}

				.adtag {
					.el-tag+.el-tag {
						margin-left: 10px;
					}
				}

				.adnum {
					margin-top: 20px;
					overflow: hidden;
					padding-left: 12px;
					margin-bottom: 20px;

					img {
						width: 30px;
						height: 30px;
						border-radius: 100%;
						float: left;
					}

					span {
						width: 30px;
						height: 30px;
						border-radius: 100%;
						float: left;
						border: 2px solid var(--white);
						margin-left: -10px;
					}

					span {
						text-align: center;
						line-height: 30px;
						background-color: var(--white);
						color: var(--info);
						position: relative;
						border: 1px solid rgba(0, 0, 0, .3)
					}

					i {
						float: left;
						color: var(--info);
						line-height: 30px;
						margin-left: 20px;
					}
				}
			}
		}
	}
</style>
